import React from "react";

import { Payments, PaymentType, paymentTypeToText } from "../../../../models";

import "./DailyPaymentsCard.scss";

export interface DailyPaymentsCardProps {
  payments: Payments;

  onViewOrders: (ids: string[]) => () => void;
}

export function DailyPaymentsCard(props: DailyPaymentsCardProps) {
  const { payments, onViewOrders } = props;

  const paymentTypes = Object.values(PaymentType).filter(
    (type) => type !== PaymentType.ACH
  );

  return (
    <div className="daily-payments-card-component">
      <div className="header">
        <div className="header-title">Payments</div>
      </div>

      <div className="items-container">
        {paymentTypes.map((type, index) => (
          <React.Fragment key={type}>
            {index > 0 && <div className="vertical-divider" />}
            <div
              className="item-container"
              onClick={onViewOrders(payments[type].ids)}
            >
              <div className="item-title">{paymentTypeToText[type]}</div>
              <div className="item-value">{payments[type].total}</div>
            </div>
          </React.Fragment>
        ))}
      </div>
    </div>
  );
}
